import { apiBlob } from '@/lib/api';

/**
 * Baixa o CSV de transações (GET /export/csv?<querystring de filtros>) reusando o
 * Bearer + auto-refresh do lib/api, transforma em object URL e dispara o download
 * via um <a download> programático. Revoga o URL ao final.
 */
export async function downloadCsv(qs: string, filename = 'transacoes.csv'): Promise<void> {
  const blob = await apiBlob(`/export/csv${qs ? `?${qs}` : ''}`);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
